import React, { useRef, useState } from "react";
import {
  Stack,
  ListItem,
  ListItemText,
  Button,
  Modal,
  Box,
  Card,
  List,
  Typography,
  IconButton,
  ListSubheader,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  CircularProgress
} from "@mui/material";
import SearchField from "./SearchField";
import { Postrequestcall } from "../../request/Postrequest";
import { FETCH_COMPANIES, FETCH_COMPANIES_2, FETCH_COMPANIES_BY_NAME_NEW, SAVE_COMPANIES } from "../../constant/Apipath";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../common/Loader";
import { useNavigate } from "react-router-dom";
import Removeduplicates from "./Removeduplicate";
import CloseIcon from "@mui/icons-material/Close";
import VerifiedIcon from "@mui/icons-material/Verified";
import WarningIcon from "@mui/icons-material/Warning";
import { English } from "../../constant/EnglishFallback";
import { setShowalert } from "../../redux/actions/actions";
const AddCompanyModal = ({ open, onClose, from, onCompanySelect }) => {

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;

  const debounceTimeout = useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSubmitLoading, setShowSubmitLoading] = useState(false);
  const [isManufacturer, setIsManufacturer] = useState(false);

  const isFromPostAJob = from === "post-a-job";

  const {
    TEXT_ADD_COMPANY_LABEL = English?.AddCompanyModal?.TEXT_ADD_COMPANY_LABEL || "Add Companies and Manufacturers",
    TEXT_COMPANY_NAME = English?.AddCompanyModal?.TEXT_COMPANY_NAME || "Company or Manufacturer Name",
    BUTTON_ADD = English?.AddCompanyModal?.BUTTON_ADD,
    TEXT_EXISTING_COMPANY = English?.AddCompanyModal?.TEXT_EXISTING_COMPANY,
    BUTTON_VIEW = English?.AddCompanyModal?.BUTTON_VIEW
  } = multiLanguageData?.AddCompanyModal || {};

  const getData = async (search = "", pageNum = 1, append = false) => {
    if (append) {
      setLoadingMore(true);
    } else {
      setIsLoading(true);
    }

    try {
      const obj = {
        PageNr: pageNum,
        NrOfRecPerPage: 20,
        FullSearch: search?.trim() || "",
        UserId: currentUserId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [{}],
        SortList: [
          { FieldName: "Verified", Direction: "DESC" },
          { FieldName: "Name", Direction: "ASC" }
        ]
      };
      const res = await Postrequestcall(FETCH_COMPANIES_BY_NAME_NEW, obj, loginData?.accessToken);
      const resData = res?.data?.data ?? [];
      const updatedCode = Removeduplicates(resData, "name");

      if (pageNum === 1) {
        setData(updatedCode);
      } else {
        setData((prev) => Removeduplicates([...prev, ...updatedCode], "name"));
      }
      setPage(pageNum);
      setHasMore(resData.length >= 20);
    } catch (error) {
      console.log("getData-> Error While Fetching Companies: ", error);
      if (pageNum === 1) setData([]);
      setHasMore(false);
    } finally {
      setIsLoading(false);
      setLoadingMore(false);
    }
  };

  React.useEffect(() => {
    if (open) {
      setSearchTerm("");
      setData([]);
      setPage(1);
      setHasMore(true);
      getData("", 1, false);
    }
  }, [open]);

  const handleScroll = (e) => {
    const target = e.currentTarget;
    if (
      target.scrollHeight - target.scrollTop - target.clientHeight <= 150 &&
      hasMore &&
      !loadingMore &&
      !isLoading
    ) {
      getData(searchTerm, page + 1, true);
    }
  };

  const showAddBtn = (value) => {
    if (!value || value.trim().length < 2) return false;
    const trimmedVal = value.trim().toLowerCase();
    const hasExactMatch = data.some((i) => (i?.name || "").trim().toLowerCase() === trimmedVal);
    return !hasExactMatch;
  };

  const onViewClick = (item) => {
    if (!item?.id) return null;
    if (item?.recordStatusId === 3) {
      alert("This company is reported");
      return;
    }
    if (isFromPostAJob) {
      onCompanySelect(item);
      onClose();
      return;
    }
    if (item?.manufacturer) {
      navigate(`/manufacture/${item?.id}`);
    } else {
      navigate(`/company/${item?.id}`);
    }
  };

  const handleAddNewCompany = async () => {
    const trimmedName = searchTerm.trim();
    if (!trimmedName) return;

    // Check if duplicate exists in existing records
    const hasExactMatch = data.some((i) => (i?.name || "").trim().toLowerCase() === trimmedName.toLowerCase());
    if (hasExactMatch) {
      dispatch(
        setShowalert({
          showAlert: true,
          title: "Duplicate Record",
          text: "A company or manufacturer with this exact name already exists."
        })
      );
      return;
    }

    try {
      setShowSubmitLoading(true);
      const saveObject = {
        userId: Number(currentUserId),
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: 0,
            Name: trimmedName,
            ModifiedBy: Number(currentUserId),
            RecordStatusId: 1,
            Manufacturer: isManufacturer
          }
        ]
      };
      const res = await Postrequestcall(SAVE_COMPANIES, saveObject, loginData?.accessToken);
      if (res?.data?.data && res?.data?.data[0]?.objData?.id) {
        const newId = res.data.data[0].objData.id;
        if (isFromPostAJob && onCompanySelect) {
          onCompanySelect({ id: newId, name: trimmedName, manufacturer: isManufacturer });
          onClose();
          return;
        }
        if (isManufacturer) {
          navigate(`/manufacture/${newId}`);
        } else {
          navigate(`/company/${newId}`);
        }
      } else {
        throw new Error("Failed to add company");
      }
    } catch (error) {
      console.log("handleAddNewCompany-> Error While Adding New Company: ", error);
      dispatch(
        setShowalert({
          showAlert: true,
          title: "Error",
          text: "Something went wrong while adding the company. Please try again."
        })
      );
    } finally {
      setShowSubmitLoading(false);
      onClose();
    }
  };

  return (
    <Modal open={open}>
      <Box className="user-modal-responsive">
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between"
          }}>
          <Typography variant="h6"> {isFromPostAJob ? "Company" : TEXT_ADD_COMPANY_LABEL}</Typography>
          <IconButton onClick={() => onClose()}>
            <CloseIcon />
          </IconButton>
        </Box>
        <SearchField
          value={searchTerm}
          onChange={(value) => {
            const searchValue = value;
            setSearchTerm(searchValue);
            setPage(1);
            setHasMore(true);
            if (debounceTimeout.current) {
              clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
              getData(searchValue, 1, false);
            }, 400);
          }}
          onSubmit={() => {
            setPage(1);
            setHasMore(true);
            getData(searchTerm, 1, false);
          }}
          placeholder={TEXT_COMPANY_NAME}
          size={"small"}
        />

        <Box
          onScroll={handleScroll}
          sx={{
            marginTop: "8px",
            paddingBottom: "10px",
            height: "430px",
            overflow: "auto",
            scrollbarWidth: "none"
          }}>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: 420
              }}>
              <Loader />
            </div>
          ) : (
            <>
              {searchTerm.trim().length > 1 && showAddBtn(searchTerm) && !isFromPostAJob && (
                <Card
                  className="pagelist-content"
                  sx={{
                    marginBottom: 1.5,
                    p: 1.5,
                    borderRadius: "10px"
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 1 }}>
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, wordBreak: "break-word" }}>
                        {searchTerm}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {isManufacturer ? "Will be created as Manufacturer" : "Will be created as Company"}
                      </Typography>
                    </Box>
                    <ToggleButtonGroup
                      size="small"
                      value={isManufacturer ? "manufacturer" : "company"}
                      exclusive
                      onChange={(e, val) => {
                        if (val !== null) {
                          setIsManufacturer(val === "manufacturer");
                        }
                      }}
                      sx={{
                        "& .MuiToggleButton-root": {
                          textTransform: "none",
                          fontWeight: 600,
                          fontSize: "0.75rem",
                          px: 1.2,
                          py: 0.35,
                          borderColor: "divider",
                          "&.Mui-selected": {
                            bgcolor: "primary.main",
                            color: "white",
                            "&:hover": { bgcolor: "primary.dark" }
                          }
                        }
                      }}
                    >
                      <ToggleButton value="company">Company</ToggleButton>
                      <ToggleButton value="manufacturer">Manufacturer</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                  <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.5 }}>
                    <Button
                      loading={showSubmitLoading}
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={handleAddNewCompany}
                      sx={{ textTransform: "none", fontWeight: 700, px: 2.5 }}
                    >
                      + Add
                    </Button>
                  </Box>
                </Card>
              )}

              {searchTerm === "" ? null : (
                <>
                  {data.length > 0 ? (
                    <List disablePadding>
                      {!isFromPostAJob && <ListSubheader sx={{ pl: 0 }}>{TEXT_EXISTING_COMPANY}</ListSubheader>}
                      <Stack sx={{ gap: 1 }} >
                        {data?.map((item, index) => {
                          const isReported = item?.recordStatusId === 3;
                          const itemIsManufacturer = !!item?.manufacturer;
                          const isVerified = Boolean(item?.verified || item?.isVerified || item?.isCompanyVerified);

                          return (
                            <Card
                              key={index.toString()}
                              className="pagelist-content"
                              sx={{
                                marginTop: "0px",
                                opacity: isReported ? 0.6 : 1,
                                p: 1.5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 1.5
                              }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flex: 1, minWidth: 0 }}>
                                <Typography
                                  variant="body2"
                                  noWrap
                                  sx={{
                                    fontWeight: 600,
                                    color: "text.primary"
                                  }}
                                >
                                  {item.name}
                                </Typography>
                                {isVerified && (
                                  <Tooltip title="This company has been verified" arrow>
                                    <VerifiedIcon sx={{ color: "#083DB8", fontSize: "1.1rem", flexShrink: 0 }} />
                                  </Tooltip>
                                )}
                              </Box>

                              <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexShrink: 0 }}>
                                {isReported && (
                                  <Tooltip title={item?.manufacturer ? "This manufacturer is reported" : "This company is reported"} arrow>
                                    <WarningIcon sx={{ color: "error.main", fontSize: "1.1rem", cursor: "pointer" }} />
                                  </Tooltip>
                                )}
                                {itemIsManufacturer && (
                                  <Box
                                    component="span"
                                    sx={{
                                      fontSize: "0.75rem",
                                      bgcolor: "error.light",
                                      color: "error.contrastText",
                                      px: 1,
                                      py: 0.25,
                                      borderRadius: 1
                                    }}
                                  >
                                    Manufacturer
                                  </Box>
                                )}
                                <Button
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                  disabled={isReported}
                                  onClick={() => onViewClick(item)}>
                                  {isFromPostAJob ? "Select" : BUTTON_VIEW}
                                </Button>
                              </Stack>
                            </Card>
                          );
                        })}
                      </Stack>
                      {loadingMore && (
                        <Box sx={{ display: "flex", justifyContent: "center", py: 1.5 }}>
                          <CircularProgress size={24} />
                        </Box>
                      )}
                    </List>
                  ) : (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                      <Typography sx={{ color: "text.secondary" }}>
                        No companies found matching your search
                      </Typography>
                    </Box>
                  )}
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default AddCompanyModal;

